import Cookie from '@wetransfer/concorde-cookie';

import { AppConfig } from '@app/core-bundle/config/app-config';

import Analytics from '@module/analytics';

export const defaultSettings = {
  id: AppConfig.termsAndConditions.consentId,
  version: AppConfig.termsAndConditions.consentVersion,
  name: AppConfig.cookies.termsAndConditions.name,
  durationInDays: 365,
  domain:
    (window &&
      window.__session__ &&
      window.__session__.settings &&
      window.__session__.settings.cookie_domain) ||
    (location && location.domain) ||
    '',
};

// Module state
let state = {
  settings: {
    ...defaultSettings,
    validCookieValue: `${defaultSettings.version}:${defaultSettings.id}`,
  },
  accepted: false,
};

const TermsAndConditions = {
  state,

  configure,

  accept,
  areAccepted,
};

/**
 * Configure Terms And Conditions
 * @param    {Object}   [opts=defaultSettings]       Configuration
 * @property {String}   [opts.id]                    Consent document ID
 * @property {String}   [opts.version]               Consent document version
 * @property {Boolean}  [opts.name]                  Consent document name
 * @property {Number}   [opts.durationInDays]        Cookie expiration
 * @property {String}   [opts.domain=wetransfer.com] The platform domain
 * @param    {Object}   [state]                      Override module state
 */
function configure(opts = {}, _state) {
  if (_state) {
    state = _state;
  }

  state.settings = {
    ...state.settings,
    ...opts,
  };
  if (!state.accepted) {
    checkForPreviousAcceptance();
  }
}

/**
 * Accept the Terms And Conditions
 */
function accept() {
  state.accepted = true;

  setCookie();

  trackConsentGranted();

  // FIXME: I shouldn't be here (see comment at enable function)
  enableTrackingInAnalytics();
}

function areAccepted() {
  if (!state.accepted) {
    checkForPreviousAcceptance();

    if (state.accepted) {
      // FIXME: I shouldn't be here (see comment at enable function)
      enableTrackingInAnalytics();
    }
  }
  return state.accepted;
}

function checkForPreviousAcceptance() {
  let cookie = getCookie();
  const prevAcceptedState = state.accepted;

  if (cookie === state.settings.validCookieValue) {
    state.accepted = true;
  } else if (cookie === '1' || cookie === state.settings.version) {
    // if cookie lacks `id:version` format, reset it and approve it
    setCookie();
    cookie = state.settings.validCookieValue;
    state.accepted = true;
  }

  // A previously set accepted state is found and applied
  if (!prevAcceptedState && state.accepted) {
    trackConsentGranted();
  }
}

function trackConsentGranted() {
  Analytics.trackConsentGranted({
    id: state.settings.id,
    version: state.settings.version,
    name: state.settings.name,
  });
}

// TODO: Move this to a cookie banner
// Accepting T&C also counts as accepting trackers.
// Remove this and add it to a cookie banner for
// a better GDPR compliance way of handling user data
function enableTrackingInAnalytics() {
  if (state.accepted) {
    Analytics.configure({ allowTracking: true });
  }
}

function setCookie() {
  Cookie.set(state.settings.name, state.settings.validCookieValue, {
    days: state.settings.durationInDays,
    domain: state.settings.domain,
  });
}

function getCookie() {
  return Cookie.get(state.settings.name);
}

export default TermsAndConditions;
